import GarLogPerformanceConstants from "./GarLogPerformanceConstants.js";
function loadStart(clientTimeInMs) {
  return {
    type: GarLogPerformanceConstants.LOAD_START,
    payload: { clientTimeInMs }
  };
}
function checkStepPropertiesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_STEP_PROPERTIES,
    payload: { clientTimeInMs, warm }
  };
}
function setStepPropertiesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_STEP_PROPERTIES,
    payload: { clientTimeInMs, warm }
  };
}
function checkPlanSummaryLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_PLAN_SUMMARY,
    payload: { clientTimeInMs, warm }
  };
}
function setPlanSummaryLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_PLAN_SUMMARY,
    payload: { clientTimeInMs, warm }
  };
}
function checkAutoShutdownLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_AUTOSHUTDOWN,
    payload: { clientTimeInMs, warm }
  };
}
function setAutoShutdownLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_AUTOSHUTDOWN,
    payload: { clientTimeInMs, warm }
  };
}
function checkAlertsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_ALERTS,
    payload: { clientTimeInMs, warm }
  };
}
function setAlertsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_ALERTS,
    payload: { clientTimeInMs, warm }
  };
}
function checkExperimentInfoLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_EXPERIMENT_INFO,
    payload: { clientTimeInMs, warm }
  };
}
function setExperimentInfoLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_EXPERIMENT_INFO,
    payload: { clientTimeInMs, warm }
  };
}
function checkAnalysesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_ANALYSES,
    payload: { clientTimeInMs, warm }
  };
}
function setAnalysesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_ANALYSES,
    payload: { clientTimeInMs, warm }
  };
}
function checkScorecardsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_SCORECARDS,
    payload: { clientTimeInMs, warm }
  };
}
function setScorecardsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_SCORECARDS,
    payload: { clientTimeInMs, warm }
  };
}
function checkHypothesisLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_HYPOTHESIS,
    payload: { clientTimeInMs, warm }
  };
}
function setHypothesisLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_HYPOTHESIS,
    payload: { clientTimeInMs, warm }
  };
}
function checkSlicesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_SLICES,
    payload: { clientTimeInMs, warm }
  };
}
function setSlicesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_SLICES,
    payload: { clientTimeInMs, warm }
  };
}
function checkWarningsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_WARNINGS,
    payload: { clientTimeInMs, warm }
  };
}
function setWarningsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_WARNINGS,
    payload: { clientTimeInMs, warm }
  };
}
function checkMetricCategoriesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_METRIC_CATEGORIES,
    payload: { clientTimeInMs, warm }
  };
}
function setMetricCategoriesLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_METRIC_CATEGORIES,
    payload: { clientTimeInMs, warm }
  };
}
function checkScorecardDataLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_SCORECARD_DATA,
    payload: { clientTimeInMs, warm }
  };
}
function setScorecardDataLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_SCORECARD_DATA,
    payload: { clientTimeInMs, warm }
  };
}
function checkScorecardInsightsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.CHECK_SCORECARD_INSIGHTS,
    payload: { clientTimeInMs, warm }
  };
}
function setScorecardInsightsLoad(clientTimeInMs, warm) {
  return {
    type: GarLogPerformanceConstants.SET_SCORECARD_INSIGHTS,
    payload: { clientTimeInMs, warm }
  };
}
function mainFunctionality(clientTimeInMs, lastPartToLoad, warm) {
  return {
    type: GarLogPerformanceConstants.MAIN_FUNCTIONALITY,
    payload: { clientTimeInMs, lastPartToLoad, warm }
  };
}
function mainFunctionalityLoad(clientTimeInMs, lastPartToLoad, warm) {
  return {
    type: GarLogPerformanceConstants.MAIN_FUNCTIONALITY_LOAD,
    payload: { clientTimeInMs, lastPartToLoad, warm }
  };
}
function fullLoad(clientTimeInMs, lastPartToLoad, warm) {
  return {
    type: GarLogPerformanceConstants.FULL_LOAD,
    payload: { clientTimeInMs, lastPartToLoad, warm }
  };
}
export {
  checkAlertsLoad,
  checkAnalysesLoad,
  checkAutoShutdownLoad,
  checkExperimentInfoLoad,
  checkHypothesisLoad,
  checkMetricCategoriesLoad,
  checkPlanSummaryLoad,
  checkScorecardDataLoad,
  checkScorecardInsightsLoad,
  checkScorecardsLoad,
  checkSlicesLoad,
  checkStepPropertiesLoad,
  checkWarningsLoad,
  fullLoad,
  loadStart,
  mainFunctionality,
  mainFunctionalityLoad,
  setAlertsLoad,
  setAnalysesLoad,
  setAutoShutdownLoad,
  setExperimentInfoLoad,
  setHypothesisLoad,
  setMetricCategoriesLoad,
  setPlanSummaryLoad,
  setScorecardDataLoad,
  setScorecardInsightsLoad,
  setScorecardsLoad,
  setSlicesLoad,
  setStepPropertiesLoad,
  setWarningsLoad
};
//# sourceMappingURL=GarLogPerformanceActions.js.map
